var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNimyaLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 27,
    viewBox: "0 0 101 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.85 26.1936V26.3436H1H3.98672H4.13672V26.1936V3.02131H4.38979L13.1014 26.2462L13.1379 26.3436H13.2419H19.1047H19.2547V26.1936V1V0.85H19.1047H16.118H15.968V1V24.1354H15.7516L7.00317 0.947052L6.96655 0.85H6.86283H1H0.85V1V26.1936Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7533 26.1936V26.3436H24.9033H27.9269H28.0769V26.1936V1V0.85H27.9269H24.9033H24.7533V1V26.1936Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6787 0.85H33.5287V1V26.1936V26.2028V26.3528H33.6787H36.5917H36.7417V26.2028V3.13193H36.9857L43.6193 26.2442L43.6505 26.3528H43.7635H48.9811H49.0941L49.1253 26.2441L55.7497 3.13193H55.9937V26.1936V26.3436H56.1437H59.0566H59.2066V26.1936V1V0.85H59.0566H53.2952H53.1823L53.151 0.958566L46.4898 24.1354H46.2456L39.5843 0.958566L39.5531 0.85H39.4401H33.6787Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4395 0.85H62.1802L62.3094 1.07475L71.2496 16.6282V26.1936V26.2028V26.3528H71.3996H74.4324H74.5824V26.2028V16.6282L83.5226 1.07475L83.6518 0.85H83.3926H79.9357H79.8478L79.8048 0.926764L73.0816 12.9444H72.7505L66.0272 0.926764L65.9843 0.85H65.8963H62.4395Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9295 0.955788L92.8968 0.85H92.7861H87.458H87.3473L87.3146 0.95574L79.5344 26.1493L79.4744 26.3436H79.6777H82.8119H82.923L82.9554 26.2374L84.9005 19.8675L84.9005 19.8675L84.9016 19.8636L85.657 17.1278L89.975 2.98444H90.2597L94.5501 17.1272L94.5508 17.1294L95.3337 19.865L95.3336 19.865L95.3344 19.8675L97.2795 26.2374L97.3119 26.3436H97.4229H100.557H100.76L100.7 26.1493L92.9295 0.955788Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNimyaLogoLight);
export default __webpack_public_path__ + "static/media/nimya-logo-light.b143749da10d2275ecb19b75f3eb017a.svg";
export { ForwardRef as ReactComponent };